import script from "./ViewMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewMain.vue?vue&type=script&setup=true&lang=ts"

import "./ViewMain.vue?vue&type=style&index=0&id=e0022fc2&lang=scss"

const __exports__ = script;

export default __exports__